import { Store } from '@ngrx/store';

import { IShoppingCartSidebarCommandFacade } from '../../domain/ports/primary/shopping-cart.ports';

import { PublicSidebarCustomCommandProps, RegisterSidebarCustomComponent, SidebarActionTypes, SidebarPublicPort } from '@features/sidebar';
import { SidebarView } from '@features/sidebar/domain/models/sidebar.models';
import { MINI_CART_COMPONENT_NAME } from '@shared/shopcart/ui/containers/mini-cart-sidebar/mini-cart-sidebar.constants';

export class SidebarCommandFacade implements IShoppingCartSidebarCommandFacade {
    constructor(
        private readonly store: Store,
    ) { }

    private registerMiniCartComponentInSidebar(): void {
        RegisterSidebarCustomComponent(
            MINI_CART_COMPONENT_NAME,
            () => import('../../ui/containers/mini-cart-sidebar/mini-cart-sidebar.component').then(
                (m) => m.MiniCartSidebarComponent
            ),
        );
    }

    public openMiniCartInSidebar() {
        this.registerMiniCartComponentInSidebar();

        this.store.dispatch(SidebarActionTypes.ShowMiniCart());

        const props: PublicSidebarCustomCommandProps = {
            component: MINI_CART_COMPONENT_NAME,
            initializeFunction: undefined,
            data: {},
            view: SidebarView.CUSTOM_NEW,
        };

        SidebarPublicPort(this.store).openSidebarCustom(props);
    }
}
